import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Geist, Geist_Mono, Playfair_Display } from 'next/font/google'
import { FilmPlayerProvider } from '@/components/generals/film-player'

const sans = Geist({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const heading = Playfair_Display({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    style: ['normal', 'italic'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <FilmPlayerProvider>
                <Component {...pageProps} />
            </FilmPlayerProvider>
        </div>
    )
}

export default App
